import axios from 'axios';
import { resultParser } from '@/services/resultParser';
// each method should query endpoint with axios and send back results
// should probably be async/await

export const resultFetcher = {
    async calculatorOne(args) {
        args = this.normaliseArguments(args);
        try {
            const response = await axios.get(process.env.VUE_APP_API_URL + '/wp-json/ir35/one/' + args.rate + '/' + args.days);
            return resultParser.parse(response.data);
        } catch (error) {
            console.error(error);
        }
    },
    async calculatorTwo(args) {
        args = this.normaliseArguments(args);
        try {
            const response = await axios.get(process.env.VUE_APP_API_URL + '/wp-json/ir35/two/' + args.assignmentRate + '/' + args.daysWorked + '/' + args.salary + '/' + args.secondSalary + '/' + args.pension + '/' + args.totalExpenses);
            if (typeof response.data.error !== "undefined") {
                return response.data;
            }
            return resultParser.parse(response.data);
        } catch (error) {
            console.error(error);
        }
    },
    async calculatorThree(args) {
        args = this.normaliseArguments(args);
        try {
            const response = await axios.get(process.env.VUE_APP_API_URL + '/wp-json/ir35/three/' + args.rate + '/' + args.days);
            return resultParser.parse(response.data);
        } catch (error) {
            console.error(error);
        }
    },
    normaliseArguments(args) {

        Object.keys(args).forEach((key) => {
            // convert null to 0
            if (args[key] === null || typeof args[key] === "undefined") {
                args[key] = 0;
            }
            // remove non alpha numeric only if sting
            if (typeof args[key] === "string")
                args[key] = args[key].replace(/[^0-9.]/g, '');
        });
        return args;
    }
}
